import { MSHttpEvent, MSUpgradeRequiredResponse } from 'src/app/adapters/http/utils/http.utils';

export class CheckVersionHttpResponse {
  min_ios_version: string;
  min_android_version: string;
  server_version: string;
}

export namespace CheckVersionEvent {
  export class UpToDate {}
  export class UpdateRequired {}
  export class Unknown {}
  export class Loading {}

  export type Spec = UpToDate | UpdateRequired | Unknown | Loading;
}

/**
 * The function maps an MSHttpEvent to a CheckVersionEvent based on its type and status.
 * @param event - The `event` parameter is of type `MSHttpEvent.Spec<string>`.
 * @returns an instance of the `CheckVersionEvent.Spec` interface. The specific instance being returned
 * depends on the type of the `MSHttpEvent.Spec` object passed as the `event` parameter. If the `event`
 * is an instance of `MSHttpEvent.Error` and has a status of `MSUpgradeRequiredResponse`, then an
 * instance of `CheckVersionEvent.Outdated` is returned. If the `event` is an instance of `MSHttpEvent.Loading`,
 * then an instance of `CheckVersionEvent.Loading` is returned. Otherwise, an instance of `CheckVersionEvent.UpToDate`
 * is returned.
 *
 * Note: If the `event` is an instance of `MSHttpEvent.Error` and has a status other than `MSUpgradeRequiredResponse`,
 * then an instance of `CheckVersionEvent.UpToDate` is returned. This is because the status
 */
export function mapMSHttpEventToCheckVersionEvent(event: MSHttpEvent.Spec): CheckVersionEvent.Spec {
  if (event instanceof MSHttpEvent.Success) {
    const state = new CheckVersionEvent.UpToDate();
    return state;
  } else if (event instanceof MSHttpEvent.Error && event.status === MSUpgradeRequiredResponse) {
    const state = new CheckVersionEvent.UpdateRequired();
    return state;
  } else if (event instanceof MSHttpEvent.Loading) {
    const state = new CheckVersionEvent.Loading();
    return state;
  } else {
    const state = new CheckVersionEvent.Unknown();
    return state;
  }
}
